import { Route } from 'react-router-dom';
import { ListLenderStatementsPage } from './list-lender-statements';
import { ListStatementsPage } from './list-statements';
import { ViewLenderStatementPage } from './view-lender-statement';
import { ViewStatementPage } from './view-statement';
import { RequireAuth } from '/src/components';

export { ListLenderStatementsPage, ListStatementsPage, ViewLenderStatementPage, ViewStatementPage };

export const statementsRoutes = [
  <Route
    path="/statements/investors"
    element={
      <RequireAuth>
        <ListLenderStatementsPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/statements/investors/:lenderId/:month"
    element={
      <RequireAuth>
        <ViewLenderStatementPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/statements"
    element={
      <RequireAuth>
        <ListStatementsPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/statements/:loanId/:month"
    element={
      <RequireAuth>
        <ViewStatementPage />
      </RequireAuth>
    }
  />,
];
